export const integrationStatus = {
  authorizationExpiresTitle: "Autorisierung läuft bald ab",
  authorizationExpiresText:
    "Bitte erneuern Sie die Autorisierung bald, um Service-Unterbrechungen zu vermeiden.",
  actionRequiredTitle: "Aktion erforderlich",
  actionRequiredText: "Bitte erneuern Sie die Autorisierung, um Service-Unterbrechungen zu vermeiden.",
  takeAction: "Aktion durchführen",
  dialogTitle: "Integration Status",
  statusLabel: "Status:",
  actionRequiredLabel: "Aktion erforderlich:",
  close: "Schließen",
  reauthorize: "Erneut autorisieren",
  viewSettings: "Einstellungen anzeigen"
};
